import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FidService {
  private currentFidSubject = new BehaviorSubject<string>('');
  public currentFid$ = this.currentFidSubject.asObservable();

  setFid(fid: string) {
    this.currentFidSubject.next(fid);
  }

  getCurrentFid(): string {
    return this.currentFidSubject.value;
  }
}
